import { post, get, postJson, put } from "../axios";

// 查询鉴定设置信息接口
export const getSkinSellerConfig = (p) => get("/skin-seller-config", p);

// 保存鉴定设置信息接口
export const saveSkinSellerConfig = (p) => postJson("/skin-seller-config", p);

//肤测参与记录
export const aiPage = (p) => postJson("/skin-analyse-member/member/page", p);

//测试记录详情
export const testRecordDetail = (p) => get("/skin-analyse-member/member/detail/page", p);

//下载数据
export const exportData = (p) => get("/skin-analyse-member/member/export", p);

//总览
export const overview = (p) => get("/skinStatistics/overView", p);

//查询分值接口
export const getScore = (p) => get("/skinStatistics/check-list", p);

//查询Ai肤测已使用数据统计接口
export const statsUsed = (p) => get('/skinAuth/usedStats', p);

//查询Ai肤测功能配置接口
export const getSkinSellerFunctionConfig = (p) => get(`/skinAuth/function`, p);

//保存Ai肤测功能配置接口
export const saveSkinSellerFunctionConfig = (p) => postJson('/skinAuth/function', p);

// ai次数使用汇总
export const getAiUsageStats = (p) => get('/activity-common/aiUsageStats', p);

// ai次数使用流水
export const getAiUsageFlow = (p) => get('/activity-common/aiUsageFlow', p);
